import type { HTMLAttributes, LiHTMLAttributes, ReactNode } from 'react'
import { cx } from '../cx'
import styles from './RowList.module.css'

export function RowList({
  variant = 'framed',
  hover = true,
  className,
  children,
  ...rest
}: Omit<HTMLAttributes<HTMLUListElement>, 'style' | 'title'> & {
  variant?: 'framed' | 'plain'
  hover?: boolean
  className?: string
  children: ReactNode
}) {
  return (
    <ul
      {...rest}
      className={cx(styles.list, className)}
      data-variant={variant}
      data-hover={hover ? undefined : 'off'}
    >
      {children}
    </ul>
  )
}

export function RowListItem({
  className,
  children,
  ...rest
}: Omit<LiHTMLAttributes<HTMLLIElement>, 'style' | 'title'> & {
  className?: string
  children: ReactNode
}) {
  return (
    <li {...rest} className={cx(styles.item, className)}>
      {children}
    </li>
  )
}
